/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { createElement } from 'react';
import {
  oneOfType,
  arrayOf,
  string,
  func,
  bool,
  shape, oneOf,
} from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { Small } from 'components/common';
import {
  evolve, when, is, over, lensProp, defaultTo,
} from 'ramda';
import { sanitize } from 'helpers/Utils';

import Icon from './Icon';

import './SegmentedControl.scss';

sanitize()(evolve({
  description: when(is(Object), over(lensProp('position'), defaultTo('pre'))),
}));
class SegmentedControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
    };

    this.onOptionClickWithOption = this.onOptionClickWithOption.bind(this);
  }

  static getDerivedStateFromProps({ value }, { selectedValue: prevValue }) {
    if ((_.isNull(value) || _.isUndefined(value)) || value === prevValue) return null;

    return {
      selectedValue: value,
    };
  }

  onOptionClickWithOption(option) {
    const { onChange } = this.props;
    const { value } = option;
    this.setState({
      selectedValue: value,
    });

    if (onChange) onChange(option);
  }

  render() {
    const {
      options,
      small,
      fluid,
      massive,
      configClasses,
      disabledOptionValues,
      title,
      error,
      isClean,
      isShowValidationIcon,
      validationText,
      dataSelectorId,
      description,
    } = this.props;
    const { selectedValue } = this.state;

    const classes = {
      'segmented-control input-wrapper': true,
      error: error && !isClean,
      small,
      fluid,
      massive,
    };
    return (
      <div className={classNames(classes)}>
        {(title) && (
          <label htmlFor={this.uniqueId} className="input-title-wrapper">
            {title && (
              <strong>{title}</strong>
            )}
          </label>
        )}
        {description?.position === 'pre' && (
          (description?.component && createElement(description.component, this.props, null))
          || description?.render(this.props)
        )}
        {description?.length && (
          <div className="segment-description-wrapper">
            <Small secondary>{description}</Small>
          </div>
        )}
        <div
          className={classNames(
            'option-border-wrapper',
            configClasses,
          )}
          data-selector={dataSelectorId}
        >
          {options.map((option, index) => {
            const { value, label, icon } = option;
            const disabled = disabledOptionValues.includes(value);
            const optionClasses = {
              option: true,
              selected: selectedValue === value,
              error: error && !isClean,
              disabled,
            };
            return (
              <div
                // eslint-disable-next-line
                key={index}
                className={classNames(optionClasses)}
                onClick={() => !disabled && this.onOptionClickWithOption(option)}
                data-selector={`${dataSelectorId}-${value}`}
              >

                <div className="content-wrapper">
                  {icon && (
                    <div className="top-icon">
                      <Icon name={icon} medium />
                    </div>
                  )}
                  <div className="segment-label-wrapper">
                    <div className="segment-label">
                      {label || value}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {error && validationText && !isClean && (
          <div className="input-validation-wrapper">
            {isShowValidationIcon && (
              <span className="input-validation-icon">
                <Icon name="info" />
              </span>
            )}
            <Small>{validationText}</Small>
          </div>
        )}
        {description?.position === 'post' && (
          (description?.component && createElement(description.component, this.props, null))
          || description?.render(this.props)
        )}
      </div>
    );
  }
}

SegmentedControl.defaultProps = {
  options: [],
  value: null,
  onChange: undefined,
  disabledOptionValues: [],
  configClasses: null,
  small: false,
  massive: false,
  fluid: false,
  error: false,
  isClean: false,
  title: '',
  validationText: null,
  isShowValidationIcon: true,
  dataSelectorId: '',
  description: null,
};

SegmentedControl.propTypes = {
  options: arrayOf(
    shape({
      value: oneOfType([string, bool]).isRequired,
      label: string,
      disabled: bool,
    })
  ),
  value: oneOfType([string, bool]),
  onChange: func,
  configClasses: string,
  disabledOptionValues: arrayOf(string),
  small: bool,
  fluid: bool,
  error: bool,
  isClean: bool,
  massive: bool,
  title: string,
  validationText: string,
  isShowValidationIcon: bool,
  dataSelectorId: string,
  description: oneOfType([
    string,
    shape({
      position: oneOf(['pre', 'post']),
      render: func,
      component: func,
    }),
  ]),
};

export default SegmentedControl;
